import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import NotificationStore from './NotificationStore';
import './NotificationCenter.css';

const typeIcons = {
    success: 'fas fa-check-circle text-success',
    error: 'fas fa-times-circle text-danger',
    warning: 'fas fa-exclamation-triangle text-warning',
    info: 'fas fa-info-circle text-info'
};

// Inbox on the top-right corner of the NavMenu giving access to the latest
// success/error messages received, even after their toasts are dismissed.
export default class NotificationInbox extends Component {

    state = {
        isOpen: false,
        history: NotificationStore.getHistory(),
        unseen: NotificationStore.getUnseenCount()
    };

    componentDidMount() {
        NotificationStore.addHistoryListener(this.handleHistoryChange);
    }

    componentWillUnmount() {
        NotificationStore.removeHistoryListener(this.handleHistoryChange);
    }

    handleHistoryChange = (history) => {
        this.setState({ history, unseen: NotificationStore.getUnseenCount() });
    }

    toggle = () => {
        // Decide open/close from prevState (avoids a race on rapid double-toggle)
        // and run the side effect in the completion callback, after state settles.
        this.setState(
            prevState => ({ isOpen: !prevState.isOpen }),
            () => {
                if (this.state.isOpen) {
                    NotificationStore.markAllSeen();
                }
            }
        );
    }

    render() {
        const { isOpen, history, unseen } = this.state;

        return (
            <Dropdown nav inNavbar isOpen={isOpen} toggle={this.toggle} className={this.props.className}>
                <DropdownToggle className="fas fa-inbox btn-lg" tag="a">

                </DropdownToggle>
                {unseen > 0 ? <Badge className="badge-notify">{unseen}</Badge> : ''}
                <DropdownMenu className="notification-inbox-menu" right>
                    <DropdownItem header><FormattedMessage id="navbar.LatestMessages" /></DropdownItem>
                    {history.length > 0 ?
                        history.map(item =>
                            <div key={item.id} className="notification-inbox-item">
                                <i className={typeIcons[item.type] || typeIcons.info} />
                                <div>
                                    {item.title ? <div className="font-weight-bold">{item.title}</div> : ''}
                                    <div>{item.message}</div>
                                </div>
                                <small className="notification-inbox-time">{moment(item.time).isSame(moment(), 'day') ? moment(item.time).format('HH:mm') : moment(item.time).format('DD/MM HH:mm')}</small>
                            </div>
                        )
                        :
                        <div className="text-muted text-center py-3">
                            <FormattedMessage id="navbar.NoRecentMessages" />
                        </div>
                    }
                </DropdownMenu>
            </Dropdown>
        );
    }
}
